import { render } from "./NewUser.vue?vue&type=template&id=7252ddcc"
import script from "./NewUser.vue?vue&type=script&lang=js"
export * from "./NewUser.vue?vue&type=script&lang=js"
script.render = render

export default script